var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3519 37.0123C10.8758 35.9313 8.87494 33.9902 7.71946 31.5479C6.56398 29.1057 6.33206 26.3276 7.06659 23.7276C7.80112 21.1275 9.4524 18.8815 11.715 17.4049C13.9776 15.9282 16.6984 15.321 19.3741 15.6954C20.183 12.721 22.0796 10.1589 24.6883 8.51685C27.2969 6.87476 30.4272 6.27244 33.4589 6.82924C36.4906 7.38603 39.2026 9.06132 41.0575 11.5232C42.9124 13.985 43.7749 17.0538 43.4741 20.1215C45.445 20.3561 47.2817 21.2397 48.6951 22.6331C50.1084 24.0265 51.018 25.8505 51.2806 27.8178C51.5431 29.7851 51.1436 31.7838 50.1451 33.4991C49.1466 35.2143 47.6058 36.5486 45.7654 37.2918",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9404 37.9436L25.6467 31.2373V51.3561",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5879 26.7656V46.8844L41.2941 40.1781",
    stroke: "#D41E4D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsSolution);
export default __webpack_public_path__ + "static/media/DevOps_Solution.c2ae2204eb7aae7a1c68d3930a6599da.svg";
export { ForwardRef as ReactComponent };